import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';

import { HttpClient } from '@angular/common/http';


@Injectable()
export class CoreAuthService extends BaseService {

  constructor(_http: HttpClient, url: string) {
        super(_http, `coreauthenticationservice`, url);
   }

}

